/**
 * 짐 목록 화면이 쓰는 데이터 선언.
 *
 * 지금까지 짐 목록은 어댑터(`MovingItemsFlowAdapter`)가 런타임에 만들어냈다. spec 을
 * SWR 로 받아서 `buildMovingItemPickerSections` 로 섹션을 나누고 FlowDocument 를 통째로
 * 조립하는 방식이라, 문서로 남는 게 없어 편집자가 볼 수도 고칠 수도 없었다.
 *
 * 여기서는 그 두 단계를 선언으로 적는다. 실제 호출은 호스트가 등록한 로더·derive 가
 * 하고, 문서는 "무엇을 어떤 인자로 부를지" 만 갖는다.
 */
import type { DataSource } from "@miso/design-system";

/** 호스트가 등록해야 하는 이름들. 오타를 문자열로 흘리지 않으려고 모아 둔다. */
export const MOVING_ITEM_REFS = {
  /** 짐 스펙 목록. 호스트가 API 로 가져온다. */
  specs: "movingItem.specs",
  /** 스펙 → item-picker 섹션. 순수 함수라 이 패키지가 구현을 갖는다. */
  pickerSections: "movingItem.pickerSections",
} as const;

/**
 * 방 타입에 맞춰 짐 목록을 만든다.
 *
 * `roomType` 은 스코프에서 읽는다 — 어느 방을 기록 중인지에 따라 "주로 쓰는 항목"
 * 섹션이 달라지기 때문이다. 없으면 derive 가 단일 "전체 품목" 으로 떨어진다.
 */
export const MOVING_ITEM_SECTIONS_DATA: DataSource[] = [
  { id: "specs", source: MOVING_ITEM_REFS.specs },
  {
    id: "sections",
    derive: MOVING_ITEM_REFS.pickerSections,
    args: { specs: { $var: "specs" }, roomType: { $var: "roomType" } },
  },
];
